import React from 'react';

export const ErrorFallback: React.FC = () => {
  return <div>Something went wrong. Please try to reload</div>;
};
export default ErrorFallback;
